import { useEffect, useState } from 'react';

export const useIsPortrait = (): boolean => {
    const [isPortrait, setIsPortrait] = useState(() => {
        // Set initial state based on current orientation
        return window.matchMedia('(orientation: portrait)').matches;
    });

    useEffect(() => {
        const mediaQuery = window.matchMedia('(orientation: portrait)');
        const onChange = (e: MediaQueryListEvent) => setIsPortrait(e.matches);

        mediaQuery.addEventListener('change', onChange);
        return () => mediaQuery.removeEventListener('change', onChange);
    }, []);

    return isPortrait;
};
